import {globalWindow} from '../../../libs/shared/helpers/src/browser/browserHelpers';

export interface Electron {
  ipcRenderer: any;
}

declare global {
  interface Window {
    electron?: Electron;
  }
}

// We are forced to get electron through the parent as you cannot require it inside an iFrame.
// Will have to change that once the app starts to host the old app.
export const electron: Electron | undefined = globalWindow.parent && globalWindow.parent.electron;
